import { FileText, Globe, Mail, MapPin, Phone } from 'lucide-react';

import type { HandleSource, HandleType } from './types';

export const HANDLE_TYPE_ICONS: Record<HandleType, typeof Phone> = {
  PHONE: Phone,
  EMAIL: Mail,
  WEBSITE: Globe,
  FAX: FileText,
  MAILING_ADDRESS: MapPin,
};

export const SOURCE_COLORS: Record<HandleSource, string> = {
  web_search: 'bg-purple-100 text-purple-700 border-purple-200',
  manual: 'bg-blue-100 text-blue-700 border-blue-200',
  document: 'bg-orange-100 text-orange-700 border-orange-200',
  import: 'bg-gray-100 text-gray-700 border-gray-200',
};

export const SOURCE_LABELS: Record<HandleSource, string> = {
  web_search: 'Web Search',
  manual: 'User Added',
  document: 'From Doc',
  import: 'Import',
};
